export default __webpack_public_path__ + "static/media/title.5e08b2d7.svg";